import { createAction, createSlice } from "@reduxjs/toolkit";
// Types
import { Document } from "../../@types/document";
import { anullDocument } from "./actions/anullDocument";
import { abandonDocument } from "./actions/abandonDocument";
import { setDocumentPending } from "./actions/setDocumentPending";
import updateArchive from "./actions/updateArchive";
import { addDocumentComment } from "./actions/addDocumentComment";
import updateDocument from "./actions/updateDocument";

interface DocumentUpdateState {
  document: Document;
  updateArchiveStatus: String;
  anullStatus: String;
  abandonStatus: String;
  updateDocumentStatus: string;
  error: boolean;
  pendingStatus: String;
  addCommentStatus: string;
  commentText: string;
}

const initialState = {
  document: {},
  updateArchiveStatus: "",
  anullStatus: "",
  abandonStatus: "",
  updateDocumentStatus: "",
  error: false,
  pendingStatus: "",
  addCommentStatus: "",
  commentText: "",
} as DocumentUpdateState;

export const setUpdatedDocument = createAction<object>("SET_UPDATED_DOCUMENT");
export const resetUpdatedDocument = createAction("RESET_UPDATED_DOCUMENT");
export const setAnullStatus = createAction<String>("SET_ANULL_STATUS");
export const setAbandonStatus = createAction<String>("SET_ABANDON_STATUS");
export const setPendingStatus = createAction<String>("SET_PENDING_STATUS");
export const setAddCommentStatus = createAction<string>("SET_ADD_COMMENT_STATUS");
export const setDocumentCommentText = createAction<string>("SET_DOCUMENT_COMMENT_TEXT");

const documentUpdateSlice = createSlice({
  name: "documentUpdate",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setUpdatedDocument, (state, { payload }) => {
        state.document = { ...state.document, ...payload };
      })
      .addCase(resetUpdatedDocument, (state) => {
        state.document = {} as Document;
      })

      .addCase(updateDocument.pending, (state) => {
        state.updateDocumentStatus = "pending";
        state.error = false;
      })
      .addCase(updateDocument.fulfilled, (state, action) => {
        state.document = {} as Document;
        state.updateDocumentStatus = "fulfilled";
        state.error = false;
      })
      .addCase(updateDocument.rejected, (state) => {
        state.updateDocumentStatus = "rejected";
        state.error = true;
      })
      /** Subir archivo */
      .addCase(updateArchive.pending, (state) => {
        state.updateArchiveStatus = "pending";
      })
      .addCase(updateArchive.fulfilled, (state, { payload }) => {
        state.updateArchiveStatus = "fulfilled";
        state.document = { ...state.document, archive: payload };
      })
      .addCase(updateArchive.rejected, (state) => {
        state.updateArchiveStatus = "rejected";
      })
      /** Anular documento */
      .addCase(anullDocument.pending, (state) => {
        state.anullStatus = "pending";
      })
      .addCase(anullDocument.fulfilled, (state, { payload }) => {
        state.anullStatus = "fulfilled";
      })
      .addCase(anullDocument.rejected, (state) => {
        state.anullStatus = "rejected";
      })
      .addCase(setAnullStatus, (state, { payload = "" }) => {
        state.anullStatus = payload;
      })

      /** Abandonar documento */
      .addCase(abandonDocument.pending, (state) => {
        state.abandonStatus = "pending";
      })
      .addCase(abandonDocument.fulfilled, (state, { payload }) => {
        state.abandonStatus = "fulfilled";
      })
      .addCase(abandonDocument.rejected, (state) => {
        state.abandonStatus = "rejected";
      })
      .addCase(setAbandonStatus, (state, { payload = "" }) => {
        state.abandonStatus = payload;
      })

      /** Activar documento */
      .addCase(setDocumentPending.pending, (state) => {
        state.pendingStatus = "pending";
      })
      .addCase(setDocumentPending.fulfilled, (state, { payload }) => {
        state.pendingStatus = "fulfilled";
      })
      .addCase(setDocumentPending.rejected, (state) => {
        state.pendingStatus = "rejected";
      })
      .addCase(setPendingStatus, (state, { payload = "" }) => {
        state.pendingStatus = payload;
      })
      .addCase(setAddCommentStatus, (state, { payload = "" }) => {
        state.addCommentStatus = payload;
      })
      .addCase(addDocumentComment.pending, (state) => {
        state.addCommentStatus = "pending";
      })
      .addCase(addDocumentComment.fulfilled, (state, { payload }) => {
        state.addCommentStatus = "fulfilled";
      })
      .addCase(addDocumentComment.rejected, (state) => {
        state.addCommentStatus = "rejected";
      })
      .addCase(setDocumentCommentText, (state, { payload }) => {
        state.commentText = payload;
      });
  },
});

export const documentUpdate = documentUpdateSlice.reducer;
